<template>
  <v-combobox
    :items="translated"
    v-model.trim="searchField"
    :placeholder="$t('labels.search')"
    :append-icon="$vuetify.icons.values.search"
    item-text="name"
    @click:append="doSearch"
    @input="doSearch"
    v-on:keyup.enter="doSearch"
    :disabled="disabled"
    clearable
    single-line
    hide-details
    hide-no-data
    :class="className"
    v-if="useCombo"
  />
  <v-text-field
    v-model.trim="searchField"
    :placeholder="$t('labels.search')"
    :append-icon="$vuetify.icons.values.search"
    @click:append="doSearch"
    v-on:keyup.enter="doSearch"
    :disabled="disabled"
    clearable
    single-line
    hide-details
    hide-no-data
    :class="className"
    v-else
  />
</template>

<script>
import { EQ_OPERATOR, AND_SEPARATOR, LIKE_OPERATOR, OR_SEPARATOR } from '../axios'
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '@argon/app/store'

export default {
  name: 'SingleSearchFilter',

  props: {
    context: { type: String, required: true },
    fields: { type: Array, default: () => [{ label: 'display', type: 'text' }] },
    disabled: { type: Boolean, default: false },
    className: { type: String, default: '' },
    start: { type: Number, default: 3 }
  },
  data() {
    return {
      error: false,
      searchField: null
    }
  },
  computed: {
    translated() {
      return this.fields
        .filter((x) => x.type === 'list')
        .map((x) => {
          let vals = x.values.map((y) => ({ name: this.$t(x.prefix ? `${x.prefix}.${y}` : `labels.${y}`), value: y }))
          return [{ divider: true }, { header: this.$t(x.label) }, ...vals]
        })
        .flat()
    },
    useCombo() {
      return this.translated.length > 1
    },
    searchableFields() {
      return this.fields.map((x) => x.label)
    },
    queryItems() {
      if (!this.searchField) {
        return []
      }
      return this.searchableFields.map((field) => ({
        field,
        operator: LIKE_OPERATOR,
        value: this.searchField.value || this.searchField
      }))
    }
  },
  methods: {
    // TODO: debounce or throttle
    ...mapActions(NAMESPACE, ['setAppliedFilter', 'clearAppliedFilter']),
    doSearch() {
      this.setAppliedFilter({
        context: this.context,
        filterObject: { separator: OR_SEPARATOR, items: this.queryItems }
      })
    }
  },
  watch: {
    searchField: function (newVal, oldVal) {
      if (!newVal) {
        return this.clearAppliedFilter(this.context)
      }
      if (newVal.length > this.start) {
        this.doSearch()
      }
    }
  }
}
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 8px;
  margin-bottom: 20px;
}
</style>
